










































import {
  defineComponent,
  PropType
} from '@nuxtjs/composition-api';
import { SfQuantitySelector, SfButton } from '~/storefrontUI/components';
import AddToWishlist from 'components/wishlist/AddToWishlist.vue';
import CompareButton from 'components/compare/CompareButton.vue';
import type { Product } from '@wemade-vsf/catalog/lib/runtime/product/types';

export default defineComponent({
  name: 'ProductActions',
  props: {
    showQuantity: {
      type: Boolean,
      default: true
    },
    showAddToCart: {
      type: Boolean,
      default: true
    },
    showWishlist: {
      type: Boolean,
      default: true
    },
    isInWishlist: {
      type: Boolean,
      default: false
    },
    isQuoteProduct: {
      type: Boolean,
      default: false
    },
    qty: {
      type: [Number, String],
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object as PropType<Product>,
      default: null
    }
  },
  model: {
    prop: "qty"
  },
  components: {
    SfQuantitySelector,
    SfButton,
    AddToWishlist,
    CompareButton,
    PriceRequestButton: () => import('components/catalog/Product/PriceRequestButton.vue')
  }
})
